<template>
  <span v-if="props.licenseNames.length > 20">
    <SmTooltip
      :content="i18n.t('views.documents.table.tooltips.download')"
      placement="top">
      <template #content>
        <TextMultiline v-for="name in props.licenseNames" :key="name">
          {{ name }}
        </TextMultiline>
      </template>
      {{ i18n.t('licensesCount', { count: props.licenseNames.length }) }}
    </SmTooltip>
  </span>
  <span v-else-if="props.licenseNames.length > 0" class="py-3">
    <TextMultiline v-for="name in props.licenseNames" :key="name">
      {{ name }}
    </TextMultiline></span
  >
  <span v-else class="italic text-muted">{{ i18n.t('general.noModel') }}</span>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  type Props = {
    licenseNames: string[]
  }

  const props = defineProps<Props>()

  const i18n = useI18n()
</script>
